import { boxShadow, mediaHelper, paletteHelper, spacingHelper } from '@property.com.au/ui-kit';
import { PageContainer } from '../../../components/PageContainer/PageContainer';
import styled from 'styled-components';
import { FunctionComponent } from 'react';
import { PropertyPageBreadCrumbs } from '../PropertyPageBreadCrumbs/PropertyPageBreadCrumbs';
import { MarketStatusWithData } from '../MarketStatusWithData/MarketStatusWithData';
import { FollowProperty } from '../PropertyRelationship/FollowProperty';
import { PropertyTitleWithData } from '../PropertyTitleWithData/PropertyTitleWithData';
import { HeaderPropertyFeaturesWithData } from '../HeaderPropertyFeatures/HeaderPropertyFeatures';
import { HeaderCtasWithData } from '../HeaderCtas/HeaderCtasWithData';
import { CompareButton } from '../PcaChatModal/subcomponents/CompareButton/CompareButton';
import { useFeatureRollout } from '@rea-argonaut/experiment';
import { usePropertyPageQuery } from '../../graphql/usePropertyPageQuery';

const PropertyPageHeaderContainer = styled.div`
  background-color: ${paletteHelper('backgroundPrimaryHigh')};
  border-bottom: 1px solid ${paletteHelper('borderPrimary')};
  padding-bottom: ${spacingHelper('medium')};
  ${boxShadow.headerBoxShadow}
`;

const PropertyPageHeaderInnerContainer = styled(PageContainer)`
  position: relative;
  padding-top: ${spacingHelper('large')};
  ${mediaHelper('tabletMax')} {
    padding-left: ${spacingHelper('large')};
    padding-right: ${spacingHelper('large')};
  }
`;

const MarketStatusAndFollowPropertyWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${spacingHelper('small')};
`;

const PropertyFeaturesWrapper = styled.div`
  padding-top: ${spacingHelper('small')};
`;

const HeaderButtonsContainer = styled.div`
  display: flex;
  column-gap: ${spacingHelper('extraSmall')};
  margin-top: ${spacingHelper('medium')};
  ${mediaHelper('mobile')} {
    row-gap: ${spacingHelper('extraSmall')};
    flex-direction: column;
  }
`;

export const PropertyPageHeader: FunctionComponent<{ isSignedIn: boolean }> = ({ isSignedIn }) => {
  const isPropertyChatEnabled = useFeatureRollout('property_chat').isEnabled();
  const pcaChatContext = usePropertyPageQuery()?.data?.propertyPageBySlugV3.pcaChatContext;
  const isPropertyForSale = pcaChatContext?.propertyStatus === 'FOR_SALE';
  return (
    <PropertyPageHeaderContainer>
      <PropertyPageBreadCrumbs />
      <PropertyPageHeaderInnerContainer>
        <MarketStatusAndFollowPropertyWrapper>
          <MarketStatusWithData />
          <FollowProperty />
        </MarketStatusAndFollowPropertyWrapper>
        <PropertyTitleWithData />
        <PropertyFeaturesWrapper>
          <HeaderPropertyFeaturesWithData />
        </PropertyFeaturesWrapper>
        <HeaderButtonsContainer>
          <HeaderCtasWithData />
          {isSignedIn && isPropertyChatEnabled && isPropertyForSale && <CompareButton />}
        </HeaderButtonsContainer>
      </PropertyPageHeaderInnerContainer>
    </PropertyPageHeaderContainer>
  );
};
